module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/note/note.component.css
// module id = ./src/app/note/note.component.css
// module chunks = main